import { useEffect } from "react";

export const useTimedCallback = (callback, period) => {
  useEffect(() => {
    var handle = setInterval(callback, period);
    return () => clearInterval(handle);
  }, []);
};
